import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { ActionStatus, AppraisalRequestList, CommonWebService, DEVICE_CREDENTIALS, HttpResponse, PmAddAppraisal, RequestAppraisal, SelfAppraisalList, UserHttpService } from "../public-api";

@Injectable({
    providedIn: 'root'
})
export class ManageAppraisalService {
    getMyReviewRating() {
        throw new Error('Method not implemented.');
    }

    constructor(
        private userService: UserHttpService,
        private commonService: CommonWebService,
        private http: HttpClient
    ) { }

    public appraisalRequest(body: RequestAppraisal): Observable<HttpResponse<any>> {
        let formData = new FormData();
        //console.log(body);
        formData.append('user_id', this.userService.getUserInfo.user_id ? this.userService.getUserInfo.user_id : "");
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id ? this.userService.getUserInfo.usr_role_track_id : "");
        formData.append('token', this.userService.userToken ? this.userService.userToken : "");
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id ? this.userService.getUserInfo.usr_customer_track_id : "");
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('employee_id', body.employee_id ? body.employee_id : "");
        formData.append('first_name', body.first_name ? body.first_name : "");
        formData.append('last_name', body.last_name ? body.last_name : "");
        formData.append('department', body.department ? body.department : "");
        formData.append('project_managerid', body.project_managerid ? body.project_managerid : "");
        formData.append('reason', body.reason ? body.reason : "");
        formData.append('attendence_rating', body.attendence_rating ? body.attendence_rating : "");
        formData.append('workethics_rating', body.workethics_rating ? body.workethics_rating : "");
        formData.append('qualityofwork_rating', body.qualityofwork_rating ? body.qualityofwork_rating : "");
        formData.append('leadershipqualities_rating', body.leadershipqualities_rating ? body.leadershipqualities_rating : "");
        formData.append('communication_rating', body.communication_rating ? body.communication_rating : "");
        formData.append('problemsolving_rating', body.problemsolving_rating ? body.problemsolving_rating : "");
        formData.append('attendence_comment', body.attendence_comment ? body.attendence_comment : "");
        formData.append('workethics_comment', body.workethics_comment ? body.workethics_comment : "");
        formData.append('qualityofwork_comment', body.qualityofwork_comment ? body.qualityofwork_comment : "");
        formData.append('leadership_comment', body.leadership_comment ? body.leadership_comment : "");
        formData.append('communication_comment', body.communication_comment ? body.communication_comment : "");
        formData.append('problemsolving_comment', body.problemsolving_comment ? body.problemsolving_comment : "");
        formData.append('appraisal_status', body.status ? body.status : "1");
        return this.http.post<HttpResponse<any>>('appraisal/create_appraisal_request', formData);
    }

    public appraisalRequestList(): Observable<HttpResponse<AppraisalRequestList[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id ? this.userService.getUserInfo.user_id : "");
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id ? this.userService.getUserInfo.usr_role_track_id : "");
        formData.append('token', this.userService.userToken ? this.userService.userToken : "");
        formData.append('customer_id', this.userService.getUserInfo.usr_customer_track_id ? this.userService.getUserInfo.usr_customer_track_id : "");
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        return this.http.post<HttpResponse<AppraisalRequestList[]>>('appraisal/appraisalRequestedList', formData);
    }

    public pmAddAppraisal(body: PmAddAppraisal): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id ? this.userService.getUserInfo.user_id : "");
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id ? this.userService.getUserInfo.usr_role_track_id : "");
        formData.append('token', this.userService.userToken ? this.userService.userToken : "");
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('request_id', body.request_id ? body.request_id : '')
        formData.append('attendence_rating', body.attendence_rating ? body.attendence_rating : '')
        formData.append('workethics_rating', body.workethics_rating ? body.workethics_rating : '')
        formData.append('qualityofwork_rating', body.qualityofwork_rating ? body.qualityofwork_rating : '')
        formData.append('leadershipqualities_rating', body.leadershipqualities_rating ? body.leadershipqualities_rating : '')
        formData.append('communication_rating', body.communication_rating ? body.communication_rating : '')
        formData.append('problemsolving_rating', body.problemsolving_rating ? body.problemsolving_rating : '')
        formData.append('attendence_comment', body.attendence_comment ? body.attendence_comment : '')
        formData.append('workethics_comment', body.workethics_comment ? body.workethics_comment : '')
        formData.append('qualityofwork_comment', body.qualityofwork_comment ? body.qualityofwork_comment : '')
        formData.append('leadership_comment', body.leadership_comment ? body.leadership_comment : "")
        formData.append('communication_comment', body.communication_comment ? body.communication_comment : '')
        formData.append('problemsolving_comment', body.problemsolving_comment ? body.problemsolving_comment : '')
        formData.append('reason', body.reason ? body.reason : "");
        formData.append('status', body.status ? body.status : "");

        return this.http.post<HttpResponse<any>>('appraisal/appraisalRevertByPM', formData);
    }

    public getMyAppraisalsList(): Observable<HttpResponse<SelfAppraisalList[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id ? this.userService.getUserInfo.user_id : "");
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id ? this.userService.getUserInfo.usr_role_track_id : "");
        formData.append('token', this.userService.userToken ? this.userService.userToken : "");
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        return this.http.post<HttpResponse<SelfAppraisalList[]>>('appraisal/myAppraisalsList', formData);
    }

    public appraisalRequestDetail(appraisal_id: string): Observable<HttpResponse<AppraisalRequestList[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id ? this.userService.getUserInfo.user_id : "");
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id ? this.userService.getUserInfo.usr_role_track_id : "");
        formData.append('token', this.userService.userToken ? this.userService.userToken : "");
        formData.append('request_id', appraisal_id ? appraisal_id : "");
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        return this.http.post<HttpResponse<AppraisalRequestList[]>>('appraisal/appraisalRequestDetail', formData);
    }

    public appraisalDetail(request_id: string): Observable<HttpResponse<SelfAppraisalList[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id ? this.userService.getUserInfo.user_id : "");
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id ? this.userService.getUserInfo.usr_role_track_id : "");
        formData.append('token', this.userService.userToken ? this.userService.userToken : "");
        formData.append('request_id', request_id ? request_id : "");
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        return this.http.post<HttpResponse<SelfAppraisalList[]>>('appraisal/Appraisal_detail', formData)
    }

    public changeAppraisalStatus(body: { status: ActionStatus, request_id: string }): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userService.userToken);
        formData.append('request_id', body.request_id ? body.request_id : "");
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        formData.append('status', body.status ? body.status : "");
        return this.http.post<HttpResponse<any>>('appraisal/appraisalsubmitbyhr', formData);
    }

}